/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Event_LabelInputs */



/**
* | output |
* | --- |
* | "Which event?" |
*
* @param {Agent_Event_Trigger_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_event_label = /** @type {((inputs?: Agent_Event_Trigger_Event_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Event_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Welches Ereignis?")
	return /** @type {LocalizedString} */ ("Which event?")
});